import React from 'react';
import { Wrapper, Button, Menu, MenuItem} from 'react-aria-menubutton';
import { useT } from "~app/BundleProvider";
import './FileMenu.scss';

const FileMenu = ({closeMenu,handleSelect}) => {
  const t = useT();
  return (
    <Wrapper
    className="FileMenu__menu"
    onSelection={handleSelect}
    id="wrapper-menu"
    role="menubar"
    >
      <Wrapper
      className="FileMenu__menu"
      onSelection={handleSelect}
      >
        <Button className='FileMenu__submenu' aria-label='Save'>
         {t("save")}
        </Button>
        <Menu className='FileMenu__submenu'>
          <MenuItem
             tabIndex="0"
             className="FileMenu__menu-item"
             value="save-to-pc"
             aria-label={t("save-my-computer")}
           >
             {t("my-computer")}
           </MenuItem>
           <MenuItem
             tabIndex="0"
             className="FileMenu__menu-item"
             value="save-to-google"
             aria-label={t("save-google")}
           >
             {t("google")}
           </MenuItem>
        </Menu>
      </Wrapper>
      <Wrapper
      className="FileMenu__menu"
      onSelection={handleSelect}
      >
        <Button className='FileMenu__submenu'>
         {t("open")}
        </Button>
        <Menu className='FileMenu__submenu'>
          <MenuItem
            tabIndex="0"
            className="FileMenu__menu-item"
            value="open-from-pc"
            aria-label={t("open-my-computer")}
          >
            {t("my-computer")}
          </MenuItem>
          <MenuItem
            tabIndex="0"
            className="FileMenu__menu-item"
            value="open-from-google"
            aria-label={t("open-google")}
          >
            {t("google")}
          </MenuItem>
        </Menu>
      </Wrapper>
      <Wrapper
      className="FileMenu__menu"
      onSelection={handleSelect}
      >
        <Button className='FileMenu__submenu'>
         {t("export")}
        </Button>
        <Menu className='FileMenu__submenu'>
          <MenuItem
            tabIndex="0"
            className="FileMenu__menu-item"
            value="export-power-point"
            aria-label={t("export-powerpoint")}
          >
            {t("power-point")}
          </MenuItem>
        </Menu>
      </Wrapper>
      <Wrapper
      className="FileMenu__menu"
       onSelection={() => closeMenu('wrapper-menu')}
      >
        <MenuItem
          tabIndex="0"
          className="FileMenu__close-icon"
          aria-label={t("close-menu")}
        >
          &#10006;
        </MenuItem>
      </Wrapper>

    </Wrapper>

  );
};

export default FileMenu;



// WEBPACK FOOTER //
// ./src/pages/Main/menu/FileMenu.js